<template>
  <a-card title="用户 Profile">
    <a-tabs v-model:activeKey="activeTab">
      <a-tab-pane key="profile" tab="用户 Profile">
        <a-space>
          <a-form layout="inline" :model="formSearch" style="margin: 10px auto;">
            <a-form-item>
              <a-input placeholder="用户 ID" v-model:value="formSearch.user_id" />
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
                @click="handleTableChange()"
                shape="circle"
              >
                <template #icon><SearchOutlined /></template>
              </a-button>
            </a-form-item>
          </a-form>
        </a-space>

        <a-descriptions title="User Info" v-if="profile">
          <a-descriptions-item label="ID">{{ profile.account?.id }}</a-descriptions-item>
          <a-descriptions-item label="昵称">{{ profile.account?.nickname }}</a-descriptions-item>
          <a-descriptions-item label="性别">{{ profile.account?.gender }}</a-descriptions-item>
          <a-descriptions-item label="地区">{{ profile.account?.region_code }}</a-descriptions-item>
          <a-descriptions-item label="是否有会员权益">
            <a-tag :color="profile.has_privileges ? 'red' : 'green'">{{ profile.has_privileges }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="是否是会员">
            <a-tag :color="profile.is_vip ? 'red' : 'green'">{{ profile.is_vip }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="是否是游客">
            <a-tag :color="profile.account.is_guest ? 'red' : 'green'">{{ profile.account.is_guest }}</a-tag>

          </a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ profile.account.created_at }}</a-descriptions-item>
          <a-descriptions-item label="注册时间">{{ profile.account.register_at }}</a-descriptions-item>
          <a-descriptions-item label="会员策略">
            <a-tag>{{ profile.member?.vip_tier_type }}</a-tag>
            (1 老策略，2 新策略，3 最新策略)
            <a-tooltip>
              <template #title>
                <div>1：每天1000积分</div>
                <div>2：2025-03-01 之前每周1750积分，每月5000积分；之后，每周500积分，每月1000积分</div>
                <div>3：每周500积分，每月1000积分</div>
              </template>
              <QuestionCircleOutlined style="margin-left: 4px; color: #999;" />
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item label="会员过期时间">{{ profile.member?.expired_at }}</a-descriptions-item>
          <a-descriptions-item label="剩余积分">
            <a @click="goToScoreDetails()">{{ profile.remain_scores }}</a>
          </a-descriptions-item>
          <a-descriptions-item label="剩余次数">
            <a @click="goToScoreDetails()">{{ profile.remain_times }}</a>
            <a-tooltip title="次数仅供参考，生成一个视频需要消耗十次，此处并未体现，具体次数请查看用户积分明细">
              <QuestionCircleOutlined style="margin-left: 4px; color: #999;" />
            </a-tooltip>
          </a-descriptions-item>
        </a-descriptions>

        <div v-if="profile">
          <a-form layout="inline" :model="userProfile" style="margin: 10px auto;">
            <a-form-item label="是否是内部用户">
              <a-radio-group v-model:value="userProfile.is_internal">
                <a-radio :value="true">是</a-radio>
                <a-radio :value="false">否</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" html-type="submit" @click="handleSubmitInternal()">
                设置内部用户状态
              </a-button>
            </a-form-item>
          </a-form>
        </div>

        <pre v-if="profile">{{ profile }}</pre>
      </a-tab-pane>

      <a-tab-pane key="scoreDetails" tab="用户积分明细">
        <a-form layout="inline" :model="scoreSearch" style="margin: 10px auto;">
          <a-form-item>
            <a-input placeholder="用户 ID" v-model:value="scoreSearch.user_id" />
          </a-form-item>
          <a-form-item>
            <a-input placeholder="任务 ID" v-model:value="scoreSearch.task_id" />
          </a-form-item>
          <a-form-item label="起始时间">
            <a-date-picker
              v-model:value="scoreSearch.start_time"
              show-time
              style="width: 200px"
              @change="handleStartTimeChange"
            />
          </a-form-item>
          <a-form-item label="截止时间">
            <a-date-picker
              v-model:value="scoreSearch.end_time"
              show-time
              style="width: 200px"
              :disabled-date="disabledEndDate"
            />
          </a-form-item>
          <a-form-item>
            <a-select
              v-model:value="scoreSearch.page_size"
              style="width: 120px"
              :options="pageSizeOptions"
            />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleScoreSearch()">搜索</a-button>
          </a-form-item>
        </a-form>

        <a-alert :message="scoreNoticeMessage" type="info" show-icon style="text-align: left; margin-bottom: 12px;" />

        <a-table
          class="ant-table-striped"
          :row-key="record => record.id"
          :data-source="scoreDetails"
          :columns="scoreColumns"
          :pagination="false"
          :loading="scoreLoading"
          :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        >
          <template #index="{ index }">
            {{ getScoreRowIndex(index) }}
          </template>
          <template #source_type="{ record }">
            {{ sourceTypeMap[record.source_type] || record.source_type }}
          </template>
          <template #task_id="{ record }">
            <a v-if="record.task_id" :href="`/home/creation/works?task_id=${record.task_id}`" target="_blank">{{ record.task_id }}</a>
            <span v-else>-</span>
          </template>
          <template #remark="{ record }">
            <span>{{ record.remark || '-' }}</span>
          </template>
          <template #createdAt="{ record }">
            <span>{{ formatDateTime(record.created_at) }}</span>
          </template>
          <template #updatedAt="{ record }">
            <span>{{ formatDateTime(record.updated_at) }}</span>
          </template>
        </a-table>
        <div style="margin-top: 12px; text-align: right;">
          <a-button
            style="margin-right: 8px;"
            :disabled="scoreLoading || scoreSearch.page <= 1"
            @click="handlePrevPage()"
          >
            上一页
          </a-button>
          <a-button type="primary" :loading="scoreLoading" @click="handleNextPage()">
            下一页
          </a-button>
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import { defineComponent } from 'vue'
import { SearchOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import request from '@/utils/request'

const scoreColumns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    slots: { customRender: 'index' },
  },
  {
    title: 'Task ID',
    dataIndex: 'task_id',
    key: 'task_id',
    slots: { customRender: 'task_id' },
  },
  {
    title: '用户 ID',
    dataIndex: 'user_id',
    key: 'user_id',
  },
  {
    title: '积分来源',
    dataIndex: 'source_type',
    key: 'source_type',
    slots: { customRender: 'source_type' },
  },
  {
    title: '扣除/增加积分',
    dataIndex: 'consume_points',
    key: 'consume_points',
  },
  {
    title: '业务单号',
    dataIndex: 'biz_id',
    key: 'biz_id',
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    slots: { customRender: 'remark' },
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    slots: { customRender: 'createdAt' },
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    key: 'updated_at',
    slots: { customRender: 'updatedAt' },
  },
]

export default defineComponent({
  components: {
    SearchOutlined,
    QuestionCircleOutlined,
  },
  data() {
    return {
      activeTab: 'profile',
      profile: null,
      loading: false,
      userProfile: {
        user_id: 0,
        is_internal: false,
      },
      formSearch: {
        user_id: '',
      },
      scoreLoading: false,
      scoreDetails: [],
      scoreColumns,
      scoreNoticeMessage: '当前第 1 页，本页 0 条',
      scoreSearch: {
        user_id: '',
        task_id: '',
        start_time: null,
        end_time: null,
        page: 1,
        page_size: 20,
      },
      pageSizeOptions: [
        { label: '每页 10 条', value: 10 },
        { label: '每页 20 条', value: 20 },
        { label: '每页 50 条', value: 50 },
        { label: '每页 100 条', value: 100 },
      ],
      sourceTypeMap: {
        1: '免费试用',
        2: '会员',
        3: '加油包',
        4: '超额扣除',
      },
    }
  },
  methods: {
    goToScoreDetails() {
      this.scoreSearch.user_id = String(this.userProfile.user_id || this.formSearch.user_id)
      this.activeTab = 'scoreDetails'
      this.scoreSearch.page = 1
      this.handleScoreTableChange()
    },
    formatDateTime(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      const pad = (n) => n.toString().padStart(2, '0')
      const year = date.getFullYear()
      const month = pad(date.getMonth() + 1)
      const day = pad(date.getDate())
      const hours = pad(date.getHours())
      const minutes = pad(date.getMinutes())
      const seconds = pad(date.getSeconds())
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    async handleSubmitInternal() {
      try {
        await request.post(`/api/users/${this.userProfile.user_id}/profile/internal`, {
          is_internal: this.userProfile.is_internal,
        })
        message.success('更新成功')
        this.handleTableChange()
      } catch (err) {
        message.error(err.message)
      }
    },
    async handleTableChange() {
      if (!this.formSearch.user_id) {
        message.warning('请输入用户 ID')
        return
      }

      this.loading = true
      try {
        const rsp = await request.get(`/api/vips/profiles/${this.formSearch.user_id}`, {})
        this.profile = rsp.data
        this.userProfile.user_id = rsp.data.account.id
        this.userProfile.is_internal = rsp.data.account.is_internal
        if (!this.scoreSearch.user_id) {
          this.scoreSearch.user_id = String(rsp.data.account.id)
        }
      } finally {
        this.loading = false
      }
    },
    handleStartTimeChange() {
      if (!this.scoreSearch.start_time || !this.scoreSearch.end_time) {
        return
      }

      const maxEndTime = this.scoreSearch.start_time.add(30, 'day')
      const isBeforeStart = this.scoreSearch.end_time.isBefore(this.scoreSearch.start_time)
      const isAfterLimit = this.scoreSearch.end_time.isAfter(maxEndTime)

      if (isBeforeStart || isAfterLimit) {
        this.scoreSearch.end_time = null
        message.warning('截止时间只能选择起始时间之后 30 天内的时间')
      }
    },
    disabledEndDate(current) {
      if (!this.scoreSearch.start_time) {
        return false
      }

      const startTime = this.scoreSearch.start_time.startOf('day')
      const maxDate = this.scoreSearch.start_time.add(30, 'day').endOf('day')
      return current.isBefore(startTime) || current.isAfter(maxDate)
    },
    handleScoreSearch() {
      this.scoreSearch.page = 1
      this.handleScoreTableChange()
    },
    handleNextPage() {
      this.scoreSearch.page += 1
      this.handleScoreTableChange()
    },
    handlePrevPage() {
      if (this.scoreSearch.page <= 1) {
        return
      }

      this.scoreSearch.page -= 1
      this.handleScoreTableChange()
    },
    getScoreRowIndex(index) {
      return (this.scoreSearch.page - 1) * this.scoreSearch.page_size + index + 1
    },
    async handleScoreTableChange() {
      if (!this.scoreSearch.user_id && !this.scoreSearch.task_id) {
        message.warning('请输入用户 ID 或任务 ID')
        return
      }

      if (this.scoreSearch.start_time && this.scoreSearch.end_time) {
        const diffDays = this.scoreSearch.end_time.diff(this.scoreSearch.start_time, 'day', true)
        if (diffDays > 30 || diffDays < 0) {
          message.warning('截止时间只能选择起始时间之后 30 天内的时间')
          return
        }
      }

      this.scoreLoading = true
      try {
        const params = {
          user_id: this.scoreSearch.user_id,
          task_id: this.scoreSearch.task_id,
          page: this.scoreSearch.page,
          page_size: this.scoreSearch.page_size,
        }

        if (this.scoreSearch.start_time) {
          params.start_time = this.scoreSearch.start_time.format('YYYY-MM-DD HH:mm:ss')
        }
        if (this.scoreSearch.end_time) {
          params.end_time = this.scoreSearch.end_time.format('YYYY-MM-DD HH:mm:ss')
        }

        const rsp = await request.get(`/api/users/scores/details`, params)
        const responseData = rsp.data || {}
        const list = Array.isArray(responseData)
          ? responseData
          : Array.isArray(responseData.data)
            ? responseData.data
          : Array.isArray(responseData.list)
              ? responseData.list
              : []

        this.scoreDetails = [].concat(list)
        this.scoreNoticeMessage = `当前第 ${this.scoreSearch.page} 页，本页 ${list.length} 条`
      } finally {
        this.scoreLoading = false
      }
    },
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>
